const UPDATE_EMPLOYEE_IMAGE = 'fulcrum/containers/User/EmployeeImage/UPDATE_EMPLOYEE_IMAGE'
const RESET_EMPLOYEE_IMAGE = 'fulcrum/containers/User/EmployeeImage/RESET_EMPLOYEE_IMAGE'
const FETCH_EMPLOYEE_IMAGE = 'fulcrum/containers/User/EmployeeImage/FETCH_EMPLOYEE_IMAGE'
const FETCH_EMPLOYEE_IMAGE_START = 'fulcrum/containers/User/EmployeeImage/FETCH_EMPLOYEE_IMAGE_START'
const FETCH_EMPLOYEE_IMAGE_SUCCESS = 'fulcrum/containers/User/EmployeeImage/FETCH_EMPLOYEES_SUCCESS'
const FETCH_EMPLOYEE_IMAGE_ERROR = 'fulcrum/containers/User/EmployeeImage/FETCH_EMPLOYEE_IMAGE_ERROR'

export {
  UPDATE_EMPLOYEE_IMAGE,
  RESET_EMPLOYEE_IMAGE,
  FETCH_EMPLOYEE_IMAGE,
  FETCH_EMPLOYEE_IMAGE_START,
  FETCH_EMPLOYEE_IMAGE_SUCCESS,
  FETCH_EMPLOYEE_IMAGE_ERROR,
}
